import React, { useEffect } from 'react';

import { LogoPainter } from '../services/LogoPainter';
import "./LogoCanvas.css";

interface LogoCanvasProps {
    instructions: any[];
}

function LogoCanvas(props: LogoCanvasProps) {
    let canvas = React.createRef<HTMLCanvasElement>();

    useEffect(() => {
        const currentCanvas = canvas.current || new HTMLCanvasElement(); // FIXME questionable.
        LogoPainter.paint(currentCanvas, props.instructions);
    });

    return (
        <canvas ref={canvas} width="800" height="300" className="theCanvas" />
    );
}

export default LogoCanvas;
